"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * TokenNeutralV2 Icon Component
 *
 * Tree-shakeable icon component for token/tag indicators.
 *
 * @example
 * ```tsx
 * import TokenNeutralV2 from '@insided/destination/icons/TokenNeutralV2'
 *
 * <TokenNeutralV2 width={16} height={16} />
 * ```
 */
var TokenNeutralV2 = function TokenNeutralV2(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Token",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M14.4 19.2V17.4H16.5C16.755 17.4 16.9687 17.3137 17.1412 17.1412C17.3137 16.9687 17.4 16.755 17.4 16.5V14.7C17.4 14.0167 17.6292 13.4292 18.0875 12.9375C18.5458 12.4458 19.1167 12.1583 19.8 12.075V11.975C19.1167 11.8417 18.5458 11.5333 18.0875 11.05C17.6292 10.5667 17.4 9.98332 17.4 9.29999V7.49999C17.4 7.24499 17.3137 7.03124 17.1412 6.85874C16.9687 6.68624 16.755 6.59999 16.5 6.59999H14.4V4.79999H16.5C17.25 4.79999 17.8875 5.06249 18.4125 5.58749C18.9375 6.11249 19.2 6.74999 19.2 7.49999V9.29999C19.2 9.55499 19.2862 9.76874 19.4587 9.94124C19.6312 10.1137 19.845 10.2 20.1 10.2H21.6V13.8H20.1C19.845 13.8 19.6312 13.8862 19.4587 14.0587C19.2862 14.2312 19.2 14.445 19.2 14.7V16.5C19.2 17.25 18.9375 17.8875 18.4125 18.4125C17.8875 18.9375 17.25 19.2 16.5 19.2H14.4ZM7.49999 19.2C6.74999 19.2 6.11249 18.9375 5.58749 18.4125C5.06249 17.8875 4.79999 17.25 4.79999 16.5V14.7C4.79999 14.445 4.71374 14.2312 4.54124 14.0587C4.36874 13.8862 4.15499 13.8 3.89999 13.8H2.39999V10.2H3.89999C4.15499 10.2 4.36874 10.1137 4.54124 9.94124C4.71374 9.76874 4.79999 9.55499 4.79999 9.29999V7.49999C4.79999 6.74999 5.06249 6.11249 5.58749 5.58749C6.11249 5.06249 6.74999 4.79999 7.49999 4.79999H9.59999V6.59999H7.49999C7.24499 6.59999 7.03124 6.68624 6.85874 6.85874C6.68624 7.03124 6.59999 7.24499 6.59999 7.49999V9.29999C6.59999 9.99999 6.37083 10.5958 5.91249 11.0875C5.45416 11.5792 4.88333 11.8667 4.19999 11.95V12.0537C4.88333 12.1179 5.45416 12.4 5.91249 12.9C6.37083 13.4 6.59999 14 6.59999 14.7V16.5C6.59999 16.755 6.68624 16.9687 6.85874 17.1412C7.03124 17.3137 7.24499 17.4 7.49999 17.4H9.59999V19.2H7.49999Z",
    fill: "currentColor"
  }));
};

var _default = TokenNeutralV2;
exports.default = _default;